import { useEffect } from 'react';

const EverflowTracking = ({ amount, customerData }) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://www.phz4dtrk.com/scripts/sdk/everflow.js';
    script.async = true;
    console.log('[Everflow] SDK loading');
    console.log('[Everflow] Amount:', amount);
    console.log('[Everflow] Customer Data:', customerData);
    script.onload = () => {
      if (window.EF) {
        console.log('[Everflow] SDK loaded');

        window.EF.configure({ tld: 'pompaworkshop.com' });

        window.EF.click({
          offer_id: window.EF.urlParameter('oid'),
          affiliate_id: window.EF.urlParameter('affid'),
          sub1: window.EF.urlParameter('sub1'),
          sub2: window.EF.urlParameter('sub2'),
          sub3: window.EF.urlParameter('sub3'),
          sub4: window.EF.urlParameter('sub4'),
          sub5: window.EF.urlParameter('sub5'),
          uid: window.EF.urlParameter('uid'),
          source_id: window.EF.urlParameter('source_id'),
          transaction_id: window.EF.urlParameter('orderId'),
        });
        window.EF.conversion({
          aid: 1,
          amount: amount,
          order_id: window.EF.urlParameter('orderId'),
          firstName: customerData.firstName,
          lastName: customerData.lastName,
          email: customerData.email,
          phone: customerData.phone,
        });
      }
    };

    document.head.appendChild(script);
  }, []);

  return null;
};

export default EverflowTracking;
